module.exports = __webpack_public_path__ + "img/banner_password.21af1e1d.png";